export const APIURL = "https://www.fsv-illtal.de/backend";
export const MAINURL = "https://www.fsv-illtal.de/backend";
export const DOMAIN = "https://www.fsv-illtal.de";
export const TOKEN = "a0a9403ea0c56e67b32b1a7acd930c";
export const IMGTOKEN = "a0a9403ea0c56e67b32b1a7acd930c";
export const PAGE = "Page";
export const SHOP = false;
export const OFFLINE = false;
